import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PrivateRoute } from './router/PrivateRoute';
import { AdminAppLayout } from './layouts/AdminAppLayout';
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import InstitutesPage from './pages/Institutes/InstitutesPage';
import FeatureFlagsPage from './pages/FeatureFlags/FeatureFlagsPage';
import SupportTicketsPage from './pages/SupportTickets/SupportTicketsPage';
import SupportTicketDetailPage from './pages/SupportTickets/SupportTicketDetailPage';
import AuditLogsPage from './pages/AuditLogs/AuditLogsPage';
import RolesPage from './pages/Roles/RolesPage';
import CacheManagementPage from './pages/Cache/CacheManagementPage';
import PlansPage from './pages/Subscriptions/PlansPage';
import SystemConfigPage from './pages/SystemConfig/SystemConfigPage';
import ErrorPanel from './components/ErrorPanel/ErrorPanel';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route element={<AdminAppLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="institutes" element={<InstitutesPage />} />
            <Route path="feature-flags" element={<FeatureFlagsPage />} />
            <Route path="support-tickets" element={<SupportTicketsPage />} />
            <Route path="support-tickets/:id" element={<SupportTicketDetailPage />} />
            <Route path="audit-logs" element={<AuditLogsPage />} />
            <Route path="roles" element={<RolesPage />} />
            <Route path="cache" element={<CacheManagementPage />} />
            <Route path="plans" element={<PlansPage />} />
            <Route path="system-config" element={<SystemConfigPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ErrorPanel />
    </BrowserRouter>
  );
}
